export enum B2bPortalRight {
  // Not specified
  None = 'None',

  // Login
  Login = 'Login',

  // Legal Entity
  LegalEntityView = 'LegalEntityView',
  LegalEntityAdd = 'LegalEntityAdd',
  LegalEntityEdit = 'LegalEntityEdit',
  LegalEntityUploadDocument = 'LegalEntityUploadDocument',

  // Merchant
  MerchantView = 'MerchantView',
  MerchantAdd = 'MerchantAdd',
  MerchantUpdate = 'MerchantUpdate',
  MerchantUploadDocument = 'MerchantUploadDocument',

  // Account
  AccountView = 'AccountView',
  AccountAdd = 'AccountAdd',
  AccountEdit = 'AccountEdit',
  AccountTransactionView = 'AccountTransactionView',
  AccountTransactionReport = 'AccountTransactionReport',
  ExtendedAccountTransactionReport = 'ExtendedAccountTransactionReport',

  // Payment
  PaymentView = 'PaymentView',
  PaymentAdd = 'PaymentAdd',
  MasterAccountTopup = 'MasterAccountTopup',
  PaymentInvoiceView = 'PaymentInvoiceView',
  PaymentReport = 'PaymentReport',
  PaymentInvoiceReport = 'PaymentInvoiceReport',
  PaymentUploadDocument = 'PaymentUploadDocument',

  // Card
  CardView = 'CardView',
  CardAdd = 'CardAdd',
  CardEdit = 'CardEdit',
  CardViewCredentials = 'CardViewCredentials',
  CardTransactionView = 'CardTransactionView',
  CardTransactionReport = 'CardTransactionReport',

  // Forex
  ForexView = 'ForexView',
  ForexAdd = 'ForexAdd',
  ForexTransactionView = 'ForexTransactionView',
  ForexTransactionReport = 'ForexTransactionReport',

  // Crypto
  CryptoAddressGet = 'CryptoAddressGet',
  CryptoPaymentAdd = 'CryptoPaymentAdd',
  CryptoFeeView = 'CryptoFeeView',
  CryptoExchange = 'CryptoExchange',

  // Compliance
  ComplianceRequestView = 'ComplianceRequestView',
  ComplianceRequestUploadDocument = 'ComplianceRequestUploadDocument',

  // Settings
  SettingsView = 'SettingsView',
  ProfileView = 'ProfileView',
  ProfileEdit = 'ProfileEdit',
  TariffView = 'TariffView',

  // User management (B2B portal)
  UsersView = 'UsersView',
  UsersAdd = 'UsersAdd',
  UsersDelete = 'UsersDelete',
  UsersEdit = 'UsersEdit',
}

// Helper function to check if user has a specific right
// Usage: hasRight(B2bPortalRight.MerchantView, vuexStore) or hasRight(right, useAuthStore()) (Pinia)
export function hasRight(right: B2bPortalRight, store?: any): boolean {
  if (!store) {
    console.warn('Store not provided. Use this function within a Vue component context or pass the store as second parameter.');
    return false;
  }
  // Pinia (e.g. useAuthStore()): getters are exposed on the store instance
  if (typeof store.hasRight === 'function') {
    return store.hasRight(right);
  }
  // Vuex
  if (typeof store.getters?.hasRight === 'function') {
    return store.getters.hasRight(right);
  }
  return false;
}

// Vue mixin for easy access to hasRight in components
export const permissionMixin = {
  data() {
    return {
      B2bPortalRight
    };
  },
  methods: {
    hasRight(right: B2bPortalRight): boolean {
      return (this as any).$store.getters.hasRight(right);
    }
  }
};
